import { getRequest, postRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  searchTerm='webrequest'
  return getRequest(`contract/get-list/${size || 15}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function find(id) {
  return getRequest(`contract/edit/${id}`)
}

export async function save(values) {
  return postRequest(`contract/save`, values)
}

export function remove(values) {
  return postRequest(`contract/delete`, values)
}
